'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/schedule.production.min.js');
} else {
  module.exports = require('./cjs/schedule.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/schedule/index.js
// module id = 183
// module chunks = 231608221292675 277693218940876